import React from "react";
import { parseLatLng, normalizeWebsite, isValidPhone } from "../../utils/geo";
const MAX_DESCRIPTION_LENGTH = 250;
const MAX_ELIGIBILITY_LENGTH = 120;
const MAX_HOURS_LENGTH = 50;

function truncate(text, max) {
  if (!text) return "";
  const clean = text.replace(/<[^>]+?>/gm, "");
  if (clean.length <= max) return clean;
  return clean.slice(0, max - 1) + "...";
}

const CartItem = React.forwardRef(function CartItem(
  { item, onSelect, onNavigate, onRemove, isSelected },
  ref
) {
  const latLng = item.latLng || parseLatLng(item.location);
  const addressLine = [item.address_1, item.address_2, item.city, item.state]
    .filter(Boolean)
    .join(", ");

  const rawPhone =
    item.program_site_phones?.phone_1 ||
    item.program_site_phones?.phone_2 ||
    item.program_phones?.phone_1 ||
    item.site_phones?.phone_1 ||
    item.agency_phones?.phone_1 ||
    null;
  const phone = isValidPhone(rawPhone) ? rawPhone : null;

  const website = normalizeWebsite(
    item.program_site_website || item.program_website || item.site_website || item.agency_website || item.website || ""
  );

  function handleRemove(e) {
    e.stopPropagation();
    if (onRemove) onRemove(item);
  }

  return (
    <div
      ref={ref}
      className={`search-result card-highlight${isSelected ? " selected" : ""}`}
      onMouseEnter={() => onSelect && onSelect(item)}
      style={{ overflow: "hidden" }}
    >
      <div className="result-container">
        <div className="resource-header">
          <h3
            className="name resource-name pointer"
            onClick={() => onNavigate ? onNavigate(item) : onSelect && onSelect(item)}
          >
            <a role="button" tabIndex={0}>
              {item.name || item.agency_name}
            </a>
          </h3>
          {item.agency_name && (
            <h6 className="agency-info label">AGENCY: {item.agency_name}</h6>
          )}
          {item.site_name && (
            <h6 className="agency-info label">LOCATION: {item.site_name}</h6>
          )}
        </div>

        {onRemove && (
          <div className="actions search-result-actions">
            <span className="cart-link-container">
              <span
                className="cart small-label pointer"
                onClick={handleRemove}
                role="button"
                tabIndex={0}
                aria-label="Remove from List"
                title="Remove from List"
              >
                <i className="cart-icon glyphicon glyphicon-trash" aria-hidden="true" />
                <span className="visually-hidden">Remove from List</span>
              </span>
            </span>
          </div>
        )}
      </div>

      {addressLine && (
        <div className="resource-location">
          {latLng ? (
            <a
              className="directions small-label"
              href={`https://www.google.com/maps/dir/?api=1&destination=${latLng.lat},${latLng.lng}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="ico ico-marker" />
              <address className="address resource-address">{addressLine}</address>
            </a>
          ) : (
            <address className="address resource-address">{addressLine}</address>
          )}
        </div>
      )}

      {item.description && (
        <p className="description resource-description">
          {truncate(item.description, MAX_DESCRIPTION_LENGTH)}
        </p>
      )}

      {item.eligibility && (
        <div className="resource-eligibility">
          <span className="small-label">
            <i className="ico ico-flag" />
            Eligibility:&nbsp;
          </span>
          <p className="eligibility">{truncate(item.eligibility, MAX_ELIGIBILITY_LENGTH)}</p>
        </div>
      )}

      {item.hours_of_operation && (
        <div className="resource-hours">
          <span className="small-label">
            <i className="ico ico-clock" />
            Hours:&nbsp;
          </span>
          <p className="hours">{truncate(item.hours_of_operation, MAX_HOURS_LENGTH)}</p>
        </div>
      )}

      {(phone || website) && (
        <div className="resource-information">
          {phone && (
            <a
              className="information-item small-label phone"
              href={`tel:${phone.replace(/\D/g, "")}`}
            >
              <i className="ico ico-mobile" />
              <span className="information">{phone}</span>
            </a>
          )}
          {website && (
            <a
              className="information-item small-label website"
              href={website}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="ico ico-computer" />
              <span className="information">Website</span>
            </a>
          )}
        </div>
      )}
    </div>
  );
});

export default CartItem;
